import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any



@Component({
  selector: 'AddExamsH',
  templateUrl: 'AddExamsH.component.html',
  styleUrls: ['AddExamsH.component.scss'],

})
export class AddExamsHComponent implements OnInit {

  display = "none";
  display1 = "none"
  public schoolId: any;
  public data: any = [];
  public userdetailes = [];
  public mappedData: any;
  public newSectionArray = [];
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public selectAllSectionFlag: boolean;
  public selectedStd = [];
  public selectedStd1 = [];
  public guru: any = [];
  public subName: any;
  public subId: any;
  public payload: any;
  public Gs: any;
  public Es: boolean = false;
  public selectSectionCount: number = 0;
  public standardName: any;
  public sectionName: any;
  public guru1: any = [];
  public ShowSubjectSecData: any = [];
  public showdata: any = [];
  public showdata1: any = [];
  public view: boolean = false;
  public Subjectid: any;
  public Subjectname: any;
  public userId :string;

  public HigherEdchildcourse: any;
  public selectedCourse: string = '';
  public HigherEdchildsemester: any;
  public selectedSemester: string = "";
  public selectedCourseAdd: string = '';
  public selectedSemesterAdd: string = "";
  public HigherEdchildexam: any;
  public selectedExam: string = '';
  public examAdd: string = '';



  

  constructor(private dataAnalyticsService: DataAnalyticsService, private messageService: MessageService,
    private noticeboardService: NoticeboardService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
  ) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.userId = this.localStorage.retrieve('id');
  }
 
  
 
  ngOnInit() {
     this.GetCourseList();
    
  }
  private GetCourseList(){
    this.dataAnalyticsService.getHigherEdChildCourseList().finally(() => { }).subscribe(
      response => {
        this.HigherEdchildcourse = response['items'];
        try {
          this.selectedCourse =  this.HigherEdchildcourse[0].CourseId;
          this.GetSemesterList()
        } catch (error) {
          
        }
        console.log('HigherEdchildcourse',this.HigherEdchildcourse)
      },
      error => {
        console.error(error);
      });
  };

  changecourse() {
   console.log("courseT",this.selectedCourse)
   this.GetSemesterList();
  };

  changecourseAdd() {
    console.log("courseAddT",this.selectedCourseAdd)
   };
 //--------------------------------------------------------------------------------------
  private GetSemesterList() {
    this.dataAnalyticsService
      .getHigherEdChildSemesterList(this.selectedCourse).finally(() => {}).subscribe(
        (response) => {
          this.HigherEdchildsemester = response;
          try {
            this.selectedSemester =  this.HigherEdchildsemester[0].Id;
            this.GetExamsList()
          } catch (error) {
            
          }
          console.log("HigherEdchildsemester", this.HigherEdchildsemester);
        },
        (error) => {
          console.error(error); 
        }
      );
  }

  changesemester() {
    console.log("semester", this.selectedSemester);
    this.GetExamsList();
  }

  changesemesterAdd() {
    console.log("semesterAdd", this.selectedSemesterAdd);
  }

 //--------------------------------------------------------------------------------------

 private GetExamsList() {
  this.dataAnalyticsService
    .getHigherEdChildExamList(this.selectedCourse, this.selectedSemester).finally(() => {}).subscribe(
      (response) => {
        this.HigherEdchildexam = response['Value'];
        console.log("HigherEdchildexam", this.HigherEdchildexam);
      },
      (error) => {
        console.error(error);
      }
    );
}
changeexam() {
  console.log("selectedExam", this.selectedExam);
}
 //--------------------------------------------------------------------------------------

 postexamModeules() {
  var payload = {
    Exam: this.examAdd,
    SemesterCourseMappingId: this.selectedCourseAdd,
  };
  
  console.log("postexamModeules",payload);

  this.dataAnalyticsService
    .postHigherEduExam(payload)
    .finally(() => {})
    .subscribe(
      (response) => {
        this.messageService.add({
          severity: "success",
          summary: "Talkative Parents",
          detail: "Exam Added Successfully",
        });
        this.display = "none";
        this.GetExamsList();
    
        console.log(response);
      },
      (error) => {}
    );
}

 //--------------------------------------------------------------------------------------

  AddExam() {
   
    this.display= "block"
  }

  EditExam() {
   
    this.display= "block"
  }

  onCloseHandled() {
    this.display = "none";
  }

}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/AddExams/AddExamsH.ts